export default {
	agent_gateway_invalid_chat_input: 'The agent request is incomplete.',
	agent_gateway_provider_capability_unsupported: 'The provider does not support this agent request.',
	agent_gateway_provider_chat_failed: 'The provider could not answer the agent request.',
	agent_gateway_provider_explorer_structured_output_unsupported: 'The Explorer requires structured output.',
	agent_gateway_provider_explorer_tool_use_unsupported: 'The Explorer requires tool use.',
	agent_gateway_provider_memory_metadata_frontier_denied: 'Memory metadata may not be sent to frontier providers.',
	agent_gateway_provider_memory_requires_exact_local:
		'This memory request requires a local provider without fallback.',
	agent_gateway_provider_memory_summary_frontier_denied: 'Memory summaries may not be sent to frontier providers.',
	agent_gateway_provider_preparer_structured_output_unsupported: 'The Preparer requires structured output.',
	agent_gateway_provider_structured_output_unsupported: 'The provider does not support structured output.',
	agent_gateway_provider_tier_conflict: 'The tier assignment is ambiguous.',
	agent_gateway_provider_tier_frontier_duplicate: 'More than one active frontier provider exists.',
	agent_gateway_provider_tier_frontier_unavailable: 'No frontier provider is available.',
	agent_gateway_provider_tier_local_duplicate: 'More than one active local provider exists.',
	agent_gateway_provider_tier_local_unavailable: 'No local provider is available.',
	agent_gateway_provider_tier_unavailable: 'No provider is available for this tier.',
	agent_list_reference_agendaList: 'Open appointments',
	agent_list_reference_documentList: 'Open documents',
	agent_list_reference_inbox: 'Open inbox',
	agent_list_reference_mailList: 'Open mail',
	agent_list_reference_messageList: 'Open messages',
	agent_list_reference_noteList: 'Open notes',
	agent_list_reference_phoneCallList: 'Open calls',
	agent_list_reference_records: 'Open records',
	agent_list_reference_taskList: 'Open tasks',
	agent_runtime_activity_hide_label: 'Hide activity',
	agent_runtime_activity_intent_classified: 'Intent classified',
	agent_runtime_activity_loop_stopped_max_steps: 'Read loop stopped',
	agent_runtime_activity_loop_stopped_unsupported_tool: 'Unsupported read tool rejected',
	agent_runtime_activity_request_cancelled: 'Request cancelled',
	agent_runtime_activity_request_failed: 'Request failed',
	agent_runtime_activity_request_started: 'Request sent',
	agent_runtime_activity_response_received: 'Response received',
	agent_runtime_activity_show_label: 'Show activity',
	agent_runtime_activity_subagent_completed: 'Specialist completed',
	agent_runtime_activity_subagent_detail_current_work: 'Work overview',
	agent_runtime_activity_subagent_detail_generic: 'Specialist',
	agent_runtime_activity_subagent_detail_ido_records: 'Record research',
	agent_runtime_activity_subagent_detail_memory: 'Memory research',
	agent_runtime_activity_subagent_detail_module_detail: 'Detail research',
	agent_runtime_activity_subagent_detail_module_list: 'Module research',
	agent_runtime_activity_subagent_failed: 'Specialist failed',
	agent_runtime_activity_subagent_started: 'Specialist started',
	agent_runtime_activity_synthesis_critical_failure: 'All sources failed',
	agent_runtime_activity_synthesis_partial_degradation: 'Some sources degraded',
	agent_runtime_activity_title: 'Activity',
	agent_runtime_activity_tool_call_requested: 'Read tool requested',
	agent_runtime_activity_tool_detail_app_context: 'App context',
	agent_runtime_activity_tool_detail_ido_detail: 'Record detail',
	agent_runtime_activity_tool_detail_ido_instances: 'Record instances',
	agent_runtime_activity_tool_detail_ido_search: 'Record search',
	agent_runtime_activity_tool_detail_inbox: 'Inbox',
	agent_runtime_activity_tool_detail_memory_backlinks: 'Memory backlinks',
	agent_runtime_activity_tool_detail_memory_links: 'Memory links',
	agent_runtime_activity_tool_detail_memory_page: 'Memory page',
	agent_runtime_activity_tool_detail_memory_search: 'Memory search',
	agent_runtime_activity_tool_detail_memory_tag: 'Memory tag',
	agent_runtime_activity_tool_detail_module_detail: 'Module detail',
	agent_runtime_activity_tool_detail_module_list: 'Module list',
	agent_runtime_activity_tool_detail_task_list_all: 'Task list (all)',
	agent_runtime_activity_tool_detail_task_list_mine: 'Task list (mine)',
	agent_runtime_activity_tool_detail_task_list_open: 'Task list (open)',
	agent_runtime_activity_tool_detail_work_overview: 'Work overview (Inbox, tasks)',
	agent_runtime_activity_tool_result_returned: 'Read tool completed',
	agent_runtime_add_context_label: 'Add to agent context',
	agent_runtime_clear_label: 'Clear chat',
	agent_runtime_close_label: 'Close',
	agent_runtime_compatibility_notice_body:
		'This panel may still use a temporary compatibility bridge for legacy flows. Runtime truth comes from gateway projections, not from local loop or lifecycle state.',
	agent_runtime_compatibility_notice_title: 'Compatibility seam',
	agent_runtime_context_drop_label: 'Drop an item here to add it to the agent context.',
	agent_runtime_context_empty: 'No detail context selected.',
	agent_runtime_context_focus_label: 'Prioritize context',
	agent_runtime_context_loading_failed: 'The mail context could not be prepared.',
	agent_runtime_context_open_label: 'Open context',
	agent_runtime_context_remove_label: 'Remove context',
	agent_runtime_context_title: 'Context',
	agent_runtime_degradation_critical_label: 'All research sources failed. This answer is incomplete.',
	agent_runtime_degradation_partial_label: 'Some research sources degraded. Treat missing details with care.',
	agent_runtime_degradation_retry_label: 'Retry research',
	agent_runtime_empty_messages: 'Ask a question about the current work.',
	agent_runtime_error_dismiss_label: 'Dismiss',
	agent_runtime_error_generic: 'The agent could not process the request.',
	agent_runtime_gateway_projection_event_label: 'Last event',
	agent_runtime_gateway_projection_status_completed: 'Completed',
	agent_runtime_gateway_projection_status_failed: 'Failed',
	agent_runtime_gateway_projection_status_label: 'Status',
	agent_runtime_gateway_projection_status_queued: 'Queued',
	agent_runtime_gateway_projection_status_running: 'Running',
	agent_runtime_gateway_projection_thread_label: 'Thread',
	agent_runtime_gateway_projection_title: 'Gateway runtime',
	agent_runtime_loop_stopped_max_steps: 'The agent stopped after too many read steps.',
	agent_runtime_loop_stopped_unsupported_tool: 'The provider requested an unsupported read tool.',
	agent_runtime_memory_proposal_block_label: 'Block',
	agent_runtime_memory_proposal_discard_label: 'Discard',
	agent_runtime_memory_proposal_open_settings_label: 'Open in settings',
	agent_runtime_memory_proposal_permission_denied:
		'Memory proposals require permission to manage your own memory pages.',
	agent_runtime_memory_proposal_save_label: 'Save',
	agent_runtime_memory_proposal_status_blocked: 'Blocked',
	agent_runtime_memory_proposal_status_discarded: 'Discarded',
	agent_runtime_memory_proposal_status_proposed: 'Proposed',
	agent_runtime_memory_proposal_status_saved: 'Saved',
	agent_runtime_model_label: 'Model',
	agent_runtime_model_settings_label: 'Model settings',
	agent_runtime_no_models: 'No models loaded',
	agent_runtime_no_providers: 'No usable provider available.',
	agent_runtime_open_label: 'Open agent',
	agent_runtime_prompt_label: 'Message',
	agent_runtime_provider_label: 'Provider',
	agent_runtime_provider_required: 'Select a provider first.',
	agent_runtime_resize_label: 'Resize agent panel',
	agent_runtime_retry_label: 'Retry',
	agent_runtime_send_label: 'Send',
	agent_runtime_settings_label: 'Agent settings',
	agent_runtime_stop_label: 'Stop',
	agent_runtime_thread_ido_instance_research: 'Record research',
	agent_runtime_thread_ido_sub_orchestrator: 'IDO/records sub-orchestrator',
	agent_runtime_thread_memory_researcher: 'Memory research',
	agent_runtime_thread_orchestrator: 'Orchestrator',
	agent_runtime_thread_skip_reason_skippedAfterHighConfidenceFinding: 'Skipped after a high-confidence finding.',
	agent_runtime_thread_skipped_summary: '{count} additional source skipped | {count} additional sources skipped',
	agent_runtime_thread_status_cancelled: 'cancelled',
	agent_runtime_thread_status_completed: 'done',
	agent_runtime_thread_status_failed: 'failed',
	agent_runtime_thread_status_queued: 'queued',
	agent_runtime_thread_status_running: 'running',
	agent_runtime_thread_status_skipped: 'skipped',
	agent_runtime_thread_subagent: 'Subagent',
	agent_runtime_thread_tree_title: 'Thread overview',
	agent_runtime_title: 'Agent',
	agent_runtime_working_label: 'Agent is working...',
};
